import {Spinner} from '../Spinner/Spinner';

type Props = {
  // onCancel: React.MouseEventHandler<HTMLButtonElement>;
  isPending?: boolean;
  children?: React.ReactNode;
};
export function DialogButtons(props: Props) {
  return (
    <div className="flex w-full flex-col gap-2 sm:flex-row-reverse sm:justify-self-end">
      {props.isPending ? <Spinner size="sm" /> : props.children}
    </div>
  );
}

DialogButtons.displayName = 'DialogButtons';
